<template>
    <div class="cruise-tabs" :class="{ menufixed: isFixed }">
        <div>
            <ul class="cruise-tabs-ul">
                <li
                    onclick="$('html, body').animate({scrollTop: $('#info_cruise').offset().top-130}, 1000);"
                >
                    <a :class="{ activemenu: active === 'info_cruise' }"
                        >De cruise</a
                    >
                </li>
                <li
                    onclick="$('html, body').animate({scrollTop: $('#info_rederij').offset().top-50}, 1000);"
                >
                    <a :class="{ activemenu: active === 'info_rederij' }"
                        >De rederij</a
                    >
                </li>
                <li
                    onclick="$('html, body').animate({scrollTop: $('#info_schip').offset().top-50}, 1000);"
                >
                    <a :class="{ activemenu: active === 'info_schip' }"
                        >Het schip</a
                    >
                </li>
                <li
                    onclick="$('html, body').animate({scrollTop: $('#info_fotos').offset().top-50}, 1000);"
                >
                    <a :class="{ active: active === 'info_fotos' }">Foto's</a>
                </li>
                <li
                    onclick="$('html, body').animate({scrollTop: $('#info_prijzen').offset().top-50}, 1000);"
                >
                    <a
                        :class="{
                            activegreen: active === 'info_prijzen',
                        }"
                        class="midgroen"
                        >Data &amp; prijzen</a
                    >
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CruiseTopMenu',
    data: function() {
        return { isFixed: false, active: 'info_cruise' }
    },

    methods: {
        handleScroll(event) {
            // Any code to be executed when the window is scrolled
            let scroll = $(window).scrollTop()

            if (
                $('#cruisepagina-content') &&
                $('#cruisepagina-content').offset() &&
                scroll >= $('#cruisepagina-content').offset().top
            ) {
                // check the offset top
                this.isFixed = true
            } else {
                this.isFixed = false
            }
            if (
                $('#info_prijzen') &&
                $('#info_prijzen').offset() &&
                scroll >= $('#info_prijzen').offset().top - 100
            ) {
                this.active = 'info_prijzen'
            } else if (
                $('#info_fotos') &&
                $('#info_fotos').offset() &&
                scroll >= $('#info_fotos').offset().top - 100
            ) {
                this.active = 'info_fotos'
            } else if (
                $('#info_schip') &&
                $('#info_schip').offset() &&
                scroll >= $('#info_schip').offset().top - 100
            ) {
                this.active = 'info_schip'
            } else if (
                $('#info_rederij') &&
                $('#info_rederij').offset() &&
                scroll >= $('#info_rederij').offset().top - 100
            ) {
                this.active = 'info_rederij'
            } else {
                this.active = 'info_cruise'
            }
        },
    },
    created() {
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    },
}
</script>
<style scoped lang="scss">
.menufixed {
    position: fixed;
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #efefef;
    left: 0;

    top: 0;
    right: 0;
    z-index: 3;
    div {
        max-width: 1020px;
        margin: auto;
        ul {
            max-width: 745px;
            li {
                padding-top: 10px;
                padding-bottom: 10px;
            }
        }
    }
}
li {
    background-color: #ffffff;
    width: calc(100% / 5);
}
.activemenu {
    color: #37b5d3;
    background: #def7fe;
}
.activegreen {
    color: white !important;
    background: #9dd057;
}
@media screen and (max-width: 900px) {
    .menufixed {
        display: flex;
        align-content: space-evenly;
        flex-wrap: wrap;
        flex-flow: row wrap;
        div {
            max-width: 100%;
            width: 100%;
            margin: initial;
        }
    }
    li {
        font-size: 12px;
        margin: 0;
        height: 44px;
        padding: initial;
        width: auto;
        max-width: 25%;
        text-align: center;
    }

    li:last-child {
        display: none;
    }
}
@media screen and (max-width: 370px) {
    li {
        font-size: 10px;
    }
}
</style>
